import styled from 'styled-components'

const ListItem = styled('li')`
  position: relative;
  margin-bottom: 16px;
`

export default ListItem
